import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Grid, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { ButtonColorPicker, Select } from 'components'

import usePermissions from 'hooks/usePermissions'

import constants from 'constants/index'
import theme from 'theme'

const ColorSpecification = ({
  titleName,
  subtitleName,
  buttonMainName,
  buttonFontName,
  controlMainName,
  controlFontName,
}) => {
  const { THEME_FONT_COLOR_OPTIONS } = constants.privacyPortal

  const { permissions } = constants

  const { permitted } = usePermissions()
  const { control, errors } = useFormContext()

  const canManagePortalTheme = permitted(
    permissions.PRIVACY_PORTAL_THEMES.MANAGE,
  )

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        component={Box}
        display="flex"
        gridGap={theme.spacing(1)}
      >
        <Typography variant="h6">{titleName}</Typography>
        <Typography variant="body2">{subtitleName}</Typography>
      </Grid>
      <Grid item xs={12}>
        <ButtonColorPicker
          name={buttonMainName}
          controlName={controlMainName}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <Controller
          as={
            <Select
              items={THEME_FONT_COLOR_OPTIONS || []}
              label={buttonFontName}
              variant="outlined"
              error={!!errors?.[controlFontName]}
              helperText={errors?.[controlFontName]?.message}
              disabled={!canManagePortalTheme}
            />
          }
          name={controlFontName}
          control={control}
          mode="onBlur"
        />
      </Grid>
    </Grid>
  )
}

ColorSpecification.propTypes = {
  titleName: PropTypes.string.isRequired,
  subtitleName: PropTypes.string,
  buttonMainName: PropTypes.string.isRequired,
  buttonFontName: PropTypes.string.isRequired,
  controlMainName: PropTypes.string.isRequired,
  controlFontName: PropTypes.string.isRequired,
}

export default ColorSpecification
